import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import DepositHistoryPage, { getDefaultPageUI } from "components/pages/DepositHistoryPage";
import { getDepositHistoryItemConfig } from "components/pages/DepositHistoryPage/components/DepositHistoryView";
import Classes, { Account } from "model";
import { useEffect } from "react";

export default function CaptureDepositsCheckImage(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding} = context.state;
    const showConsumerAccounts = Account.hasConsumerAccounts(branding);
    const { key, value } = getDepositHistoryItemConfig(showConsumerAccounts ? "0" : "4");

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ key ], { ...value, accordionActive: true, showChecks: true })
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });
    
    return <DepositHistoryPage ui={ ui } />
}